import React, { useEffect, useRef } from 'react';
import ReactPinInput from 'react-pin-input';
import useFormatById from 'src/hooks/utils/useFormatById';
import formatTimer from "./useTimer";

const ConfirmPin = ({
  pinTimer,
  onChangePinCode,
  pinCodeDisabled,
  autoFocus
}) => {
  const formatMessage = useFormatById();
  const pinCodeRef = useRef();

  // clear pin code when disabled
  useEffect(() => {
    if (pinCodeDisabled && pinCodeRef.current?.clear) {
      pinCodeRef.current?.clear();
    }
  }, [pinCodeDisabled, pinCodeRef]);

  useEffect(() => {
    let timeout;
    if (autoFocus) timeout = setTimeout(() => {
      pinCodeRef.current.elements[0].input.focus();
    }, 0);
    return () => { if (timeout) clearTimeout(timeout); }
  }, [autoFocus]);

  return (
    <div className="confirm-pin text-center mt-4">
      <div className="enter-code">
        <label className="form-label timer-header" htmlFor="enter-pin-code">
          {formatMessage("enter-pin-code")}
        </label>
      </div>
      <div className="timer text-brand-pink timer-tick">
        {formatTimer(pinTimer)}
      </div>
      <div className="enter-pin-code text-primary case-on my-2 pt-2">
        <ReactPinInput
          ref={r => pinCodeRef.current = r}
          length={4}
          initialValue=""
          onChange={onChangePinCode}
          onComplete={onChangePinCode}
          type="numeric"
          inputMode="number"
          autoSelect={true}
          disabled={pinCodeDisabled}
        />
      </div>
    </div>
  );
};

export default ConfirmPin;
